import moment from 'moment'

/**
 * Sprawdza czy data jest poprawna i nie powoduje fallbacku momenta
 */
function isValidDate(date) {
    if (!date) return false
    const m = moment(date, moment.ISO_8601, true)
    return m.isValid()
}

/**
 * Normalizuje przesunięcie czasu
 */
function normalizeDiff(diffMs) {
    return typeof diffMs === 'number' && !isNaN(diffMs)
        ? diffMs
        : 0
}

/**
 * ISO string bez przesunięć lokalnych
 */
export function getCreatedAt(date) {
    if (!isValidDate(date)) return ''
    return moment(date).toISOString(false)
}

/**
 * DD.MM.YYYY
 */
export function formatDate(date, diffMs = 0) {
    if (!isValidDate(date)) return ''

    return moment
        .utc(date)
        .add(normalizeDiff(diffMs), 'milliseconds')
        .format('DD.MM.YYYY')
}

/**
 * HH:mm:ss
 */
export function formatTime(date, diffMs = 0) {
    if (!isValidDate(date)) return ''

    return moment
        .utc(date)
        .add(normalizeDiff(diffMs), 'milliseconds')
        .format('HH:mm:ss')
}

/**
 * DD.MM.YYYY HH:mm:ss
 */
export function formatDateTime(date, diffMs = 0) {
    if (!isValidDate(date)) return ''

    return moment
        .utc(date)
        .add(normalizeDiff(diffMs), 'milliseconds')
        .format('DD.MM.YYYY HH:mm:ss')
}

/**
 * CountdownTimer deadline
 * YYYY/MM/DD HH:mm:ss
 */
export function formatCountdownDeadline(date) {
    if (!isValidDate(date)) return ''

    return moment(date)
        .format('YYYY/MM/DD HH:mm:ss')
}
